<template>
    <div class="translations-edit translations-edit-text-area">
        <div
            class="translation-item"
            v-for="(text, language) in translationData"
            :key="language"
        >
            <ui5-label class="language">
                {{ getEmoji(language) }} {{ language }}
            </ui5-label>
            <description-editor
                v-model="translationData[language]"
                :datafields="datafields"
            />
            <div
                class="error"
                :key="language + '-error'"
                v-if="getErrorFromValidator($v.translationData[language])"
            >
                {{ trans(getErrorFromValidator($v.translationData[language])) }}
            </div>
        </div>
    </div>
</template>

<script>
import ErrorHelper from '../helpers/ErrorHelper';
import { maxLength } from 'vuelidate/lib/validators';
import DescriptionEditor from './productTypes/DescriptionEditor';
import LocalizationHelper from '../helpers/LocalizationHelper';
import validHtml from '../validators/validHtml';

export default {
    components: { DescriptionEditor },
    props: {
        translationData: {
            type: Object,
            required: true,
        },
        datafields: {
            type: Array,
            required: true,
        },
        validateHtml: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getEmoji: LocalizationHelper.languageCodeToEmoji,
        getErrorFromValidator:
            ErrorHelper.getErrorFromValidatorWithoutDirtyCheck,
    },
    computed: {},
    validations() {
        const labelValidations = {};
        Object.keys(this.translationData).forEach((x) => {
            labelValidations[x] = {
                maxLength: maxLength(65535),
            };
            if (this.validateHtml) {
                labelValidations[x].validHtml = validHtml;
            }
        });

        return {
            translationData: labelValidations,
        };
    },
};
</script>
